module.exports = __webpack_public_path__ + "img/big_1_43.e836e6b2.png";